import { connect } from "react-redux";
import NoMatch from "../components/NoMatch";

const mapStateToProps = ({ Misc }) => ({
    language: Misc.Settings.language
});

const mapDispatchToProps = dispatch => ({});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NoMatch);
